<ng-container *ngIf="vm$ | async as vm">
  <!-- Loading State -->
  <section *ngIf="vm.showSkeleton">
    <dgx-profile-overview-loading
      [ownerIsViewing]="vm.ownerIsViewing"
    ></dgx-profile-overview-loading>
  </section>

  <!-- Empty State Owner -->
  <section *ngIf="!vm.showSkeleton && vm.hasNoSkills && vm.ownerIsViewing">
    <div class="l_flex l_flex-column l_flex-center-children center-text">
      <div class="empty-state-container guts-p-t-1-half">
        <img
          alt=""
          role="presentation"
          [src]="emptyImageUrl | blobifyUrl: true"
          class="guts-p-b-2"
        />

        <h2 class="par par-light font-semibold guts-p-b-half">
          {{ 'dgProfileOverview_OverviewEmptyStateTitle' | translate }}
        </h2>

        <h2 class="par par--light_a guts-p-b-1">
          {{ 'dgProfileOverview_OverviewEmptyStateText' | translate }}
        </h2>

        <button
          (click)="goToWizard()"
          df-button
          dfButtonType="primary"
          data-dgat="data-table-77d"
        >
          <df-icon class="guts-m-r-half" icon="arrow-forward"></df-icon>
          {{ 'dgProfileOverview_OverviewCompleteWizardButton' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- Empty State Non-Owner -->
  <section *ngIf="!vm.showSkeleton && vm.hasNoSkills && !vm.ownerIsViewing">
    <div class="l_flex l_flex-column l_flex-center-children center-text">
      <div class="empty-state-container guts-p-t-1-half">
        <img
          alt=""
          role="presentation"
          [src]="nonOwnerEmptyImageUrl | blobifyUrl: true"
          width="360px"
          height="275px"
          class="guts-p-b-2"
        />

        <h2 class="par par-light font-semibold guts-p-b-half">
          {{ 'dgProfileOverview_NonOwnerEmptyStateTitle' | translate }}
        </h2>

        <h2 class="par par--light_a guts-p-b-1">
          {{ nonOwnerEmptyStateText }}
        </h2>
      </div>
    </div>
  </section>

  <section *ngIf="!vm.hasNoSkills" class="guts-m-h-1-half">
    <div class="l_flex m-no-guts guts-m-t-1-half">
      <div class="left-panel l_flex l_flex-column guts-m-r-1-half m-guts-m-h-0">
        <dgx-overview-skills-table
          *ngIf="!vm.showSkeleton"
          class="full-width guts-m-b-1"
          [skills]="vm.skills | camelCase"
          [isOwner]="vm.ownerIsViewing"
          data-dgprop-render-method="Overview Skills List"
          [signalHistories]="vm.signalHistories"
          [signalCounts]="vm.signalCounts"
          [maxSkills]="maxSkills"
          [historyXAxisLabels]="vm.historyXAxisLabels"
          [signalSummaries]="vm.signalSummaries"
          [owner]="owner"
        ></dgx-overview-skills-table>
        <div
          *ngIf="vm.showBuildYourProfile"
          class="grid sidebar-row full-width"
        >
          <div class="grid__col-xs-6">
            <ng-container *ngTemplateOutlet="skillSuggestions"></ng-container>
          </div>
          <div class="grid__col-xs-4">
            <ng-container *ngTemplateOutlet="buildYourProfile"></ng-container>
          </div>
        </div>
        <div *ngIf="vm.showActivity" class="l_flex sidebar-row guts-m-h-1-half">
          <ng-container *ngTemplateOutlet="profileActivity"></ng-container>
        </div>

        <ng-container *ngIf="experiencesList$ | async as experiences">
          <dgx-profile-experiences-v2
            *ngIf="vm.showExperiences"
            [experiences]="experiences"
            [profileName]="owner.vanityUrl"
            [ownerIsViewing]="vm.ownerIsViewing"
            [pageType]="'overview'"
            [isPageLoading]="vm.showSkeleton"
            class="guts-m-t-1"
          ></dgx-profile-experiences-v2>
        </ng-container>

        <ng-container *ngIf="achievementsList$ | async as achievements">
          <dgx-profile-overview-achievements-v2
            *ngIf="vm.showAchievements"
            [achievements]="achievements"
            [isPageLoading]="vm.showSkeleton"
            [profile]="owner"
            [ownerIsViewing]="vm.ownerIsViewing"
            [achievementDisplayLimit]="3"
            [useLoadingTemplate]="false"
            [isRestrictedView]="false"
            [isMobile]="isMobile"
            class="guts-m-t-2"
          >
          </dgx-profile-overview-achievements-v2>
        </ng-container>
        <ng-container *ngIf="learningsList$ | async as learnings">
          <dgx-profile-learning-v2
            [learnings]="learnings"
            [profileName]="owner.vanityUrl"
            [ownerIsViewing]="vm.ownerIsViewing"
            [learningDisplayLimit]="3"
            [isPageLoading]="vm.showSkeleton"
            [useLoadingTemplate]="false"
            [isMobile]="isMobile"
            class="guts-m-t-2"
          >
          </dgx-profile-learning-v2>
        </ng-container>
      </div>
      <div
        *ngIf="vm.showBuildYourProfile"
        class="l_flex guts-m-h-1-half sidebar-column"
      >
        <ng-container *ngTemplateOutlet="skillSuggestions"></ng-container>
        <ng-container *ngTemplateOutlet="buildYourProfile"></ng-container>
      </div>

      <div
        *ngIf="vm.showActivity"
        class="l_flex l_flex-justify-right guts-m-h-1-half activity-sidebar"
      >
        <ng-container *ngTemplateOutlet="profileActivity"></ng-container>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <dgx-footer-glasses *ngIf="!vm.showSkeleton"></dgx-footer-glasses>

  <ng-template #skillSuggestions>
    <dgx-profile-skill-suggestions
      *ngIf="vm.isLoggedIn"
      [isSuggestedTagsLoading]="isSuggestedTagsLoading"
      [suggestedTags]="suggestedTags"
      [tags]="tags"
      (onAddSuggestedTag)="addSuggestedTag($event)"
    ></dgx-profile-skill-suggestions>
  </ng-template>

  <ng-template #buildYourProfile>
    <dgx-build-your-profile
      *ngIf="!vm.showSkeleton"
      [skillsCount]="vm.skills.other.length"
      [focusSkillsCount]="vm.skills.focus.length"
      [skillRatingsCount]="vm.skillRatingsCount"
      [learningsCount]="vm.collectionCounts.learningsCount"
      [achievementsCount]="vm.collectionCounts.achievementsCount"
      [experiencesCount]="vm.collectionCounts.experiencesCount"
      [hasParsedResume]="vm.hasParsedResume"
      [ownerKey]="vm.ownerKey"
    ></dgx-build-your-profile>
  </ng-template>

  <ng-template #profileActivity>
    <dgx-profile-activity
      *ngIf="!vm.showSkeleton"
      [skillsCount]="vm.skills.other.length"
      [skillRatingsCount]="vm.skillRatingsCount"
      [learningsCount]="vm.collectionCounts.learningsCount"
      [achievementsCount]="vm.collectionCounts.achievementsCount"
      [experiencesCount]="vm.collectionCounts.experiencesCount"
    ></dgx-profile-activity>
  </ng-template>
</ng-container>
